import { track } from './track';
import type { AnalyticEventData, TrackWithDetailsProps } from './types';

declare const window: Window & {
  analytics?: SegmentAnalytics.AnalyticsJS;
  FS?: {
    getCurrentSessionURL: (includeCompleteURL: boolean) => string;
  };
};

const trackWithDetails = ({
  event,
  category,
  component,
  cta,
  metricValue,
  type,
  pathname,
  ...additionalAttributes
}: TrackWithDetailsProps) => {
  const attrs: AnalyticEventData = {
    component,
    type,
    cta,
    url: window.location.href,
    path: window.location.pathname,
    ...additionalAttributes,
  };

  if (window.FS !== undefined && typeof window.FS.getCurrentSessionURL === 'function') {
    attrs.fullstorySession = window.FS.getCurrentSessionURL(true);
  }

  track(event, category, attrs, metricValue);
};

export { trackWithDetails };
